





















































import { Component, Prop, Watch } from 'vue-property-decorator'
import ViewBase from '@/util/ViewBase'
import { studentBind } from '@/api/admin'
import XLSX from 'xlsx'
import { batchAddStudent } from './student.api'

@Component
export default class StudentUploadInfo extends ViewBase {
  @Prop({ type: Boolean, default: true }) visible!: boolean
  @Prop({ type: Array, default: [] }) data!: any
  @Prop({ type: Number, default: 0 }) classId!: number

  labelCol = { span: 24 }

  wrapperCol = { span: 24 }

  lang = {}

  isEdit = false

  school = ''

  form = {}

  svisible = false

  listenChange: boolean = false

  columns: any = null

  totalInfo: number = 0

  rightInfo: number = 0

  wrongInfo: number = 0

  get i18n() {
    const value = this.$t('login')
    return value as any
  }
  setColumns() {
    this.columns = this.columns = [
      {
        title: this.i18n.vStudentList.stuIndex,
        customRender: (text: any, record: any, index: any) => `${index + 1}`
      },
      {
        title: this.i18n.vStudentList.stuName,
        dataIndex: 'stu_name'
      },
      {
        title: this.i18n.vStudentList.stuNumber,
        dataIndex: 'stu_number'
      },

      {
        title: this.i18n.vStudentList.status,
        dataIndex: 'qualified',
        scopedSlots: { customRender: 'qualified' }
      }
    ]
  }
  async onOk() {
    const data = this.data
    const studentData = data.map((item: any) => {
      const stu: any = {}
      if (item.qualified == 1) {
        stu.stu_name = item.stu_name
        stu.stu_number = item.stu_number
        return stu
      }
    })
    const pdata = {
      studentData,
      class_id: this.classId
    }
    try {
      const res = await batchAddStudent(pdata)
      this.$message.success(this.i18n.vAccountForm.operationSuccess)
      this.$emit('onOk')
    } catch (ex) {
      this.handleError(ex)
    }
  }
  created() {
    this.school = JSON.parse(localStorage.school).school_key
    this.lang = this.i18n.vBinding
    this.form = this.$form.createForm(this)
    const lang: any = this.lang
    this.setColumns()
  }
  @Watch('visible')
  watchVisible(visible: any) {
    this.svisible = visible
    if (!visible) {
      this.listenChange = false
    } else {
      this.totalInfo = this.data.length
      this.rightInfo = 0
      this.wrongInfo = 0
      this.data.forEach((element: any) => {
        if (element.qualified == 1) {
          this.rightInfo += 1
        } else {
          this.wrongInfo += 1
        }
      })
    }
  }
  onCancel() {
    const form: any = this.form
    form.resetFields()
    this.$emit('onCancel')
  }
}
